const KEY_CODES = {
  BACKSPACE: 8,
  DELETE: 46,
  LEFT_ARROW: 37,
  RIGHT_ARROW: 39,
  SPACE: 32,
  TAB: 9
};

export const ALLOWED_KEY_CODES = [
  KEY_CODES.SPACE,
  KEY_CODES.TAB,
  KEY_CODES.BACKSPACE,
  KEY_CODES.DELETE,
  KEY_CODES.LEFT_ARROW,
  KEY_CODES.RIGHT_ARROW
];



// WEBPACK FOOTER //
// ./src/app/shared/components/input-with-counter/allowed-key-codes.constant.ts